import React, { useState } from 'react';
import styled from 'styled-components';
import apiConfig from '../../config/api.config';

const TestContainer = styled.div`
  max-width: 500px;
  margin: 50px auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  color: #333;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  
  &:hover {
    background: #0056b3;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const Message = styled.div<{ type: 'success' | 'error' }>`
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
  background: ${props => props.type === 'success' ? '#d4edda' : '#f8d7da'};
  color: ${props => props.type === 'success' ? '#155724' : '#721c24'};
  border: 1px solid ${props => props.type === 'success' ? '#c3e6cb' : '#f5c6cb'};
`;

const TestRegister: React.FC = () => {
  const [formData, setFormData] = useState({
    proveedor_nombre: '',
    proveedor_nit: '',
    username: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch(apiConfig.endpoints.testSimpleRegistro, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ type: 'success', text: `✅ Registro exitoso! ID: ${data.proveedor_id}` });
        setFormData({ proveedor_nombre: '', proveedor_nit: '', username: '' });
      } else {
        setMessage({ type: 'error', text: `❌ Error: ${data.error}` });
      }
    } catch (error) {
      setMessage({ type: 'error', text: `❌ Error de conexión: ${error}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <TestContainer>
      <Title>🧪 Prueba de Registro Básico</Title>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="proveedor_nombre"
          placeholder="Nombre del Proveedor *"
          value={formData.proveedor_nombre}
          onChange={handleChange}
          required
        />
        <Input
          type="text"
          name="proveedor_nit"
          placeholder="NIT *"
          value={formData.proveedor_nit}
          onChange={handleChange}
          required
        />
        <Input
          type="text"
          name="username"
          placeholder="Username *"
          value={formData.username}
          onChange={handleChange}
          required
        />
        <Button type="submit" disabled={loading}>
          {loading ? 'Registrando...' : 'Probar Registro'}
        </Button>
      </Form>
      
      {message && (
        <Message type={message.type}>
          {message.text}
        </Message>
      )}
    </TestContainer>
  );
};

export default TestRegister;
